module.exports = __webpack_public_path__ + "img/shunrui.ed56bf82.jpeg";